import { inject, Injectable } from '@angular/core';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { from, map, combineLatestWith, mergeMap } from 'rxjs';

import * as AuthSelectors from '@fantaz/shared/auth';
import { USER_TYPES } from '@fantaz/shared/config/static';
// TODO: remove circular dependency
import { FzGoogleTagManagerService } from '@fantaz/shared/data-access/api';

import * as GoogleAnalyticActions from './google-analytic.actions';

@Injectable()
export class CoreGoogleAnalyticEffects {
  actions$ = inject(Actions);
  store = inject(Store);
  gtmService = inject(FzGoogleTagManagerService);

  showDialogMessage$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(GoogleAnalyticActions.trackEvent),
        combineLatestWith(this.store.select(AuthSelectors.getCurrentUser)),
        mergeMap(([{ event }, currentUser]) => {
          console.log('[CoreGoogleAnalyticEffects/pushTag]', event);
          const user_type = currentUser?.membershipInfo.type
            ? USER_TYPES[currentUser?.membershipInfo.type.toLocaleLowerCase()]
            : USER_TYPES['guest'];
          const user = currentUser?.user;
          return from(
            this.gtmService.pushTag({
              ...event,
              ...(user && {
                userId: user.uuid,
                user_name: user.username,
                sponsor: user.sponsorUsername,
                user_type,
              }),
            }),
          );
        }),
        map(() => {
          console.log('[CoreGoogleAnalyticEffects/pushTag] sent!');
        }),
      ),
    { dispatch: false },
  );
}
